'use strict';

function assertArgument(exists) {
  if (!exists) {
    throw new TypeError('Argument required');
  }
}

module.exports = assertArgument;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/assertArgument.js
// module id = 334
// module chunks = 1